import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SearchIcon from '@mui/icons-material/Search';
import { string } from 'prop-types';

const SelectProductCard = ({ title, subtitle }) => (
  <Stack
    sx={{
      alignItems: 'center',
      backgroundColor: 'graphic.lighter',
      height: { lg: 155, xs: 255 },
      justifyContent: 'center',
      mt: { lg: 8, xs: 2 },
      p: 3,
      width: '100%',
    }}
  >
    <SearchIcon sx={{ color: 'graphic.icons', height: 38, mb: 1, width: 38 }} />
    <Typography
      sx={{
        color: 'text.secondary',
        fontWeight: 400,
        textAlign: 'center',
      }}
      variant="h6"
    >
      {title}
    </Typography>
    <Typography sx={{ color: 'text.secondary', textAlign: 'center' }} variant="body1">
      {subtitle}
    </Typography>
  </Stack>
);

SelectProductCard.propTypes = {
  subtitle: string.isRequired,
  title: string.isRequired,
};

export default SelectProductCard;
